import { useEffect, useState } from "react";
import { getAppUIDevice, getScreenAppUIBrackPoint } from "../helpers/screen-width";

const useScreenSize = () => {

    const [screenAppUIDeviceSize, setScreenAppUIDeviceSize] = useState(getAppUIDevice(window.innerWidth));
    const [screenSize, setScreenSize] = useState(getScreenAppUIBrackPoint(window.innerWidth));

    useEffect(() => {

        const handleResize = () => {

            const screenWidth = window.innerWidth;

            setScreenSize(getScreenAppUIBrackPoint(screenWidth));
            setScreenAppUIDeviceSize(getAppUIDevice(screenWidth));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        screenSize,
        screenAppUIDeviceSize,
        isMobileDevice
    };

    function isMobileDevice(): boolean {

        return screenAppUIDeviceSize === 'SMART_PHONE_SIZE';
    }
};

export default useScreenSize;
